"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputSearchRow = InputSearchRow;
exports.default = InputSearch;
var React = _interopRequireWildcard(require("react"));
var _Input = _interopRequireDefault(require("./Input"));
var _Icon = _interopRequireWildcard(require("../Icon"));
var _Button = _interopRequireDefault(require("../Button"));
var _utils = require("../utils");
var _Popup = _interopRequireDefault(require("../Popup"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// ----- COMPONENT

function InputSearchRow(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-input-search-row', props.className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "_label"
  }, props.label), props.children);
}
function InputSearch(props) {
  var defaultOpen = props.defaultOpen,
    onChange = props.onChange,
    onOk = props.onOk,
    onRefresh = props.onRefresh;
  var _useState = (0, React.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = (0, React.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    popup = _useState4[0],
    setPopup = _useState4[1];
  var _useState5 = (0, React.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  var onTextChange = function onTextChange(v) {
    if (focus) setFocus(false);
    if (popup) setPopup(false);
    setValue(v);
    dOnTextChange(v);
  };
  var dOnTextChange = (0, _index.debounce)(function (v) {
    if (props.onChange) props.onChange(v);
  }, 500);

  // {text,color,icon,onClear}

  var onFocus = function onFocus() {
    setFocus(true);
    setTimeout(function () {
      return setPopup(true);
    }, 200);
  };
  var closePopup = function closePopup() {
    setTimeout(function () {
      setFocus(false);
      setPopup(false);
    }, 200);
  };

  // -----

  (0, React.useEffect)(function () {
    if (defaultOpen) setPopup(true);
  }, [defaultOpen]);
  (0, React.useEffect)(function () {
    setValue(props.value);
  }, [props.value]);
  var tags = (0, React.useMemo)(function () {
    if ((0, _utils.isEmpty)(props.tags)) return null;
    return props.tags && props.tags.map(function (t, x) {
      return /*#__PURE__*/React.createElement(_Icon.Tag, {
        key: 'tag_' + t.text + '_' + x,
        label: t.text,
        icon: t.icon,
        color: t.color,
        onClear: t.onClear
      });
    });
  }, [props.tags]);
  var inputProps = {
    icon: props.icon === undefined ? 'search' : props.icon === false ? undefined : props.icon,
    className: (0, _utils.clsNames)('un-input-search', props.className),
    prepend: tags,
    apppend: (0, _utils.isFunction)(onRefresh) ? /*#__PURE__*/React.createElement(_Icon.default, {
      button: true,
      name: 'sync green',
      onClick: onRefresh
    }) : false,
    sm: props.sm,
    lg: props.lg,
    m0: props.m0
  };
  if (!!onChange) {
    inputProps.value = value;
    inputProps.onChange = function (v) {
      return onTextChange(v);
    };
    inputProps.onFocus = onFocus;
    inputProps.onBlur = function () {
      return setFocus(false);
    };
  } else {
    inputProps.readOnly = true;
    inputProps.onClick = function () {
      return setFocus(true);
    };
  }
  return /*#__PURE__*/React.createElement(_Input.default, inputProps, props.children && (focus || popup) && /*#__PURE__*/React.createElement(_Popup.default, {
    className: props.classPopup,
    onClose: closePopup
  }, props.children, (0, _utils.isFunction)(onOk) && /*#__PURE__*/React.createElement(_Button.default, {
    primary: true,
    className: "btn-ok",
    onClick: function onClick() {
      setPopup(false);
      if (onOk) onOk();
    }
  }, props.okLabel || 'OK')));
}